import React from "react";
import "./Quotation.css";
import { useEffect, useState } from "react";
import DesktopNavbar from "../../components/Navbar/Desktop/DesktopNavbar";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import DesktopMiniDrawer from "../../components/MiniDrawer/DesktopMiniDrawer/DesktopMiniDrawer";
import QuotationTopButtons from "../../components/QuotationTopButtons/QuotationTopButtons";
import { BorderLeft } from "@mui/icons-material";
import MobileNavbar from "../../components/Navbar/Mobile/MobileNavbar";
import MobileMiniDrawer from "../../components/MiniDrawer/MobileMiniDrawer/MobileMiniDrawer";

function Quotation() {
  const [isMiniDrawerVisible, setIsMiniDrawerVisible] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleMiniDrawer = () => {
    setIsMiniDrawerVisible(!isMiniDrawerVisible);
  };

  return (
    <div>
      <div
        style={{ backgroundColor: "#F2F4F6" }}
        className="orderSummary-mobile-hide"
      >
        <div
          style={{ padding: "0px", margin: "0px" }}
          className="container-fluid navbar-mobile-hide"
        >
          <DesktopNavbar />
        </div>
        <div className="row p-0">
          <div className="col-2 p-0">
            <DesktopMiniDrawer />
          </div>
          <div className="col-10 mb-4" style={{ marginTop: "90px" }}>
            <QuotationTopButtons />
            <div
              className="container-fluid p-3"
              style={{
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
              }}
            >
              <div
                className="container-fluid  p-0"
                style={{ borderRadius: "8px" }}
              >
                <div
                  style={{ height: "55px" }}
                  className="row order-main-list p-0"
                >
                  <div className="col-lg-10 col-md-8 order-main-list-left p-0">
                    <div className="d-flex justify-content-between align-items-center order-main-list-left-top">
                      <h4
                        style={{
                          color: "#3D3D3D",
                          fontSize: "24px",
                          borderBottom: "4px solid #5B489D",
                          marginBottom: "-5px",
                          fontWeight: "bold",
                        }}
                      >
                        QUOTATION
                      </h4>
                    </div>
                  </div>
                  <div className="col-lg-2 col-md-4  p-0  d-flex justify-content-end align-items-center">
                    <div
                      style={{
                        border: "2px solid #6a6a6a",
                        padding: "7px",
                        borderRadius: "7px",
                      }}
                      className="d-flex justify-content-between align-items-center"
                    >
                      <FileDownloadIcon
                        style={{ color: "#6a6a6a", marginRight: "auto" }}
                      />
                      <button
                        style={{
                          border: "none",
                          outline: "none",
                          backgroundColor: "white",
                        }}
                        className=""
                      >
                        Download Estimate
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <h4 className="heading mt-2">Bill To</h4>
              <div
                style={{
                  backgroundColor: "white",
                  border: "2px solid #DEE2E6",
                }}
                className="row  mb-4"
              >
                <div className="col-6 px-0">
                  <div className="col-lg-12 col-md-12 itinerary-main-list-right">
                    <div
                      style={{ borderLeft: "none" }}
                      className="row itinerary-main-list-right-content"
                    >
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Owner Name
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            Vasant Mahajan
                          </h4>
                        </div>
                      </div>
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Estimate
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            EST-2525
                          </h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row "
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Estimate Date
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            09/10/23
                          </h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Expiry Date
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            09/10/23
                          </h4>
                        </div>
                      </div>
                    </div>{" "}
                    <div class="container-fluid p-0  text-start">
                      <div
                        style={{ borderBottom: "2px solid #DEE2E6" }}
                        class="row"
                      >
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#6a6a6a",
                            backgroundColor: "#F8F9FA",
                            margin: "0px",
                            padding: "14px 26px 14px 12px",
                          }}
                          class="col-6"
                        >
                          Cage
                        </h4>
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#474747",
                            padding: "14px 26px 14px 12px",
                            margin: "0px",
                          }}
                          class="col-6"
                        >
                          28 Inches
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 px-0">
                  <div className="col-lg-12 col-md-12 itinerary-main-list-right">
                    <div
                      style={{ borderLeft: "none" }}
                      className="row itinerary-main-list-right-content"
                    >
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Owner Name
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            Vasant Mahajan
                          </h4>
                        </div>
                      </div>
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Estimate
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            EST-2525
                          </h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row "
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Estimate Date
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            09/10/23
                          </h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Expiry Date
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                              margin: "0px",
                            }}
                            class="col-6"
                          >
                            09/10/23
                          </h4>
                        </div>
                      </div>
                    </div>{" "}
                    <div class="container-fluid p-0  text-start">
                      <div
                        style={{ borderBottom: "2px solid #DEE2E6" }}
                        class="row"
                      >
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "bold",
                            color: "#6a6a6a",
                            backgroundColor: "#F8F9FA",
                            margin: "0px",
                            padding: "14px 26px 14px 12px",
                          }}
                          class="col-6"
                        >
                          Cage
                        </h4>
                        <h4
                          style={{
                            fontSize: "16px",
                            fontWeight: "500",
                            color: "#474747",
                            padding: "14px 26px 14px 12px",
                            margin: "0px",
                          }}
                          class="col-6"
                        >
                          28 Inches
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h4 className="heading mt-3">Estimate</h4>
              <table class="table table-responsive quotation-table">
                <thead style={{ backgroundColor: "#F0F0F0" }}>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Item & Description</th>
                    <th scope="col">HSN/SAC</th>
                    <th scope="col">Quantity</th>
                    <th scope="col">Rate</th>
                    <th scope="col">Taxable Amount</th>
                    <th
                      style={{ borderBottom: "1px solid #DEE2E6" }}
                      className="text-center"
                      scope="col"
                      colSpan="2"
                    >
                      CGST
                    </th>
                    <th
                      style={{ borderBottom: "1px solid #DEE2E6" }}
                      className="text-center"
                      scope="col"
                      colSpan="2"
                    >
                      SGST
                    </th>
                    <th scope="col">Total</th>
                  </tr>
                  <tr>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th className="text-center" scope="col">
                      %
                    </th>
                    <th className="text-center" scope="col">
                      Amount
                    </th>
                    <th className="text-center" scope="col">
                      %
                    </th>
                    <th className="text-center" scope="col">
                      Amount
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Sample Item</td>
                    <td>1234</td>
                    <td>2</td>
                    <td>500.00</td>
                    <td>1000.00</td>
                    <td className="text-center">9%</td>
                    <td className="text-center">90.00</td>
                    <td className="text-center">9%</td>
                    <td className="text-center">90.00</td>
                    <td>1000.00</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Another Item</td>
                    <td>5678</td>
                    <td>5</td>
                    <td>300.00</td>
                    <td>1500.00</td>
                    <td className="text-center">9%</td>
                    <td className="text-center">135.00</td>
                    <td className="text-center">9%</td>
                    <td className="text-center">135.00</td>
                    <td>1000.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="container-fluid p-3 mt-4"
              style={{
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
              }}
            >
              <h4 className="heading mt-3">Payment Details</h4>
              <div
                style={{
                  backgroundColor: "white",
                  border: "2px solid #DEE2E6",
                }}
                className="row  mb-4"
              >
                <div className="col-6 px-0">
                  <div className="col-lg-12 col-md-12 itinerary-main-list-right">
                    <div
                      style={{ borderLeft: "none" }}
                      className="row itinerary-main-list-right-content"
                    >
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Token Payment
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Payment (%)
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row "
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Online Payment
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Payment Mode
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 px-0">
                  <div className="col-lg-12 col-md-12 itinerary-main-list-right">
                    <div
                      style={{ borderLeft: "none" }}
                      className="row itinerary-main-list-right-content"
                    >
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Token Payment
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Payment (%)
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row "
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Online Payment
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>{" "}
                      <div class="container-fluid p-0  text-start">
                        <div
                          style={{ borderBottom: "2px solid #DEE2E6" }}
                          class="row"
                        >
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              color: "#6a6a6a",
                              backgroundColor: "#F8F9FA",
                              margin: "0px",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          >
                            Payment Mode
                          </h4>
                          <h4
                            style={{
                              fontSize: "16px",
                              fontWeight: "500",
                              color: "#474747",
                              padding: "14px 26px 14px 12px",
                            }}
                            class="col-6"
                          ></h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile version  */}
      <div
        style={{ backgroundColor: "#F2F4F6" }}
        className="orderSummary-mobile-show"
      >
        <div
          style={{
            padding: "0px",
            margin: "0px",
            opacity: isMiniDrawerVisible ? 0.5 : 1,
            transition: "opacity 0.3s",
          }}
          className="container-fluid"
        >
          <MobileNavbar onToggle={toggleMiniDrawer} active="ordersummary" />
        </div>
        <div className="row p-0">
          <div
            className="col-12 p-0 mobile-view-show"
            style={{
              opacity: isMiniDrawerVisible ? 0.5 : 1,
              transition: "opacity 0.3s",
              marginTop: "81px",
            }}
          >
            <QuotationTopButtons />
            <div
              className="container-fluid p-3"
              style={{
                borderRadius: "8px",
                backgroundColor: "white",
                boxShadow:
                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
              }}
            >
              <div
                className="container-fluid  p-0"
                style={{ borderRadius: "8px" }}
              >
                <div className="row p-0">
                  <div className="col-lg-12 p-0">
                    <div className="">
                      <h4 style={{ margin: "0px" }} className="heading">
                        Quotation
                      </h4>
                      <div className="container-fluid p-0 mt-3">
                        <div
                          style={{ backgroundColor: "#F6F3FF" }}
                          className="container-fluid px-3 py-3 mb-3"
                        >
                          <h4
                            style={{
                              color: "#6a6a6a",
                              fontSize: "14px",
                              margin: "0px",
                            }}
                          >
                            {" "}
                            Please download the file to view your quotation.
                          </h4>
                        </div>
                      </div>
                      <div className="col-lg-2 col-md-4  p-0  d-flex justify-content-end align-items-center">
                        <div
                          style={{
                            border: "2px solid #5B489D",
                            padding: "7px",
                            borderRadius: "7px",
                          }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <FileDownloadIcon
                            style={{
                              fontSize: "14px",
                              color: "#5B489D",
                              marginRight: "auto",
                            }}
                          />
                          <button
                            style={{
                              color: "#5B489D",
                              border: "none",
                              outline: "none",
                              backgroundColor: "white",
                              fontSize: "14px",
                            }}
                            className=""
                          >
                            Download Estimate
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="py-2 mt-3 mb-4"
              style={{ backgroundColor: "white", borderRadius: "7px" }}
            >
              <h4
                style={{
                  marginLeft: "17px",
                  marginRight: "17px",
                  fontSize: "20px",
                }}
                className="heading mt-3"
              >
                Payment Details
              </h4>
              <div className="container-fluid px-3">
                <div
                  style={{
                    backgroundColor: "white",
                    border: "2px solid #DEE2E6",
                  }}
                  className="row mb-3"
                >
                  <div className="col-12 px-0">
                    <div className="col-lg-12 col-md-12 itinerary-main-list-right">
                      <div
                        style={{ borderLeft: "none" }}
                        className="row itinerary-main-list-right-content"
                      >
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ borderBottom: "2px solid #DEE2E6" }}
                            class="row"
                          >
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#6a6a6a",
                                backgroundColor: "#F8F9FA",
                                margin: "0px",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            >
                              Token Payment
                            </h4>
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#474747",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            ></h4>
                          </div>
                        </div>
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ borderBottom: "2px solid #DEE2E6" }}
                            class="row"
                          >
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#6a6a6a",
                                backgroundColor: "#F8F9FA",
                                margin: "0px",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            >
                              Payment (%)
                            </h4>
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#474747",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            ></h4>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div
                            style={{ borderBottom: "2px solid #DEE2E6" }}
                            class="row "
                          >
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#6a6a6a",
                                backgroundColor: "#F8F9FA",
                                margin: "0px",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            >
                              Online Payment
                            </h4>
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#474747",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            ></h4>
                          </div>
                        </div>{" "}
                        <div class="container-fluid p-0  text-start">
                          <div class="row">
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "bold",
                                color: "#6a6a6a",
                                backgroundColor: "#F8F9FA",
                                margin: "0px",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            >
                              Payment Mode
                            </h4>
                            <h4
                              style={{
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#474747",
                                padding: "8px 0px 8px 12px",
                              }}
                              class="col-6"
                            ></h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {isMiniDrawerVisible && (
            <div className="col-12">
              <MobileMiniDrawer onClose={toggleMiniDrawer} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Quotation;
